import { createContext } from 'react'

const LocatorContext = createContext('')
LocatorContext.displayName = 'LocatorContext'

export default LocatorContext
